import ShareWechat from './components/app/ShareWechat.vue';
export default {
  components: {
    ShareWechat
  },
  computed: {
    path() {
      return this.$route.path;
    },
    keepAlive() {
      return (this.$route.meta || {}).keepAlive;
    },
    stateAudio() {
      const {
        audio
      } = this.$store.state;
      return audio;
    }
  },
  methods: {
    fnResize() {
      // const deviceWidth = document.documentElement.clientWidth || window.innerWidth;
      // document.documentElement.style.fontSize = `${deviceWidth / 30}px`;
      // 折叠屏vw计算比例
      const viewportWidth = process?.env?.VUE_APP_VIEWPORT_WIDTH || 375;
      const ratio = this.isFoldableScreen ? viewportWidth / window.screen.width : 1;
      const viewportRatio = ratio < 0.34 ? 0.34 : ratio;
      // const left = this.isFoldableScreen ? '33vw' : '0';
      const left = this.isFoldableScreen ? '0' : '0';
      document.documentElement.style.setProperty('--viewport-ratio', viewportRatio);
      document.documentElement.style.setProperty('--viewport-left', left);
      document.documentElement.style.setProperty('--viewport-right', left);
    }
  },
  beforeCreate() {
    // zeeho APP或小程序内webview无token时
    if ((this.isMiniapp || this.isApp) && !/token=[\w_-]+/.test(window.location.hash)) {
      localStorage.removeItem('token');
    }
  },
  mounted() {
    window.addEventListener('resize', this.fnResize);
    this.fnResize();
    // app兼容
    document.body.parentNode.className = document.body.parentNode.className + (this.isApp ? 'is-app' : '');
    // 解决ios不支持按钮:active伪类的方法
    document.body.addEventListener('touchstart', () => {});

    // 解决ios输入表单被键盘顶上后无法恢复的问题
    if (this.isApple) {
      let oldScrollTop = 0;
      let isFocus = false; // 防止输入框之前切换时界面上下滚动
      const handleFocus = e => {
        isFocus = true;
        // e.target.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          // console.log('focus');
          oldScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          isFocus = false;
          // ios 16系统键盘顶不上去
          function isiOS16() {
            var ua = navigator.userAgent;
            var iosVersionStr = /OS (\d+)_(\d+)_?(\d+)?/.exec(ua);
            var version = iosVersionStr ? parseInt(iosVersionStr[1], 10) : null;
            return version === 16;
          }
          if (['INPUT', 'TEXTAREA'].some(val => val === e.target.tagName) && oldScrollTop === 0 && isiOS16()) {
            document.documentElement.scrollTop = document.body.scrollHeight;
          }
        }, 100);
      };
      const handleBlur = () => {
        console.log(oldScrollTop, document.documentElement.scrollTop || document.body.scrollTop);
        setTimeout(() => {
          if (isFocus) return;
          if (window.scrollTo) {
            // console.log('blur');
            window.scrollTo(0, oldScrollTop);
          }
        }, 50);
      };
      document.addEventListener('focus', handleFocus, true);
      document.addEventListener('blur', handleBlur, true);
    }
  },
  watch: {
    $route: {
      deep: true,
      handler(newValue) {
        // 滚动条自动滚动5px，然后回位(避免ios回退偶现白屏)
        const meta = newValue.meta || {};
        console.log(meta);
        this.$nextTick(() => {
          if (window.scrollTo) {
            const scrollTop = document.documentElement.scrollTop + 5;
            window.scrollTo(0, document.documentElement.scrollHeight);
            window.scrollTo(0, scrollTop);
          }
        });

        // // 没有启用分享配置的页面使用默认分享配置
        // if (!meta.visibleShare) {
        //   this.$nextTick(() => {
        //     const { href } = window.location;
        //     homeJssdkSignApi({
        //       debug: this.$route.query.debug,
        //     }).then(() => {
        //       weixinShare({ link: `${href.split('#')[0]}` });
        //     });
        //   });
        // }
        if (!meta.visibleAudio) {
          this.$audio.pause();
        } else {
          // this.$audio.src = this.stateAudio.src;
          // this.$audio.src = `http://oss-cfmoto.zeehoev.com/codes/cfmoto-h5/music.mp3?t=${new Date().getTime()}`;
          // this.$audio.loop = true;
          // this.$audio.play();
        }
      }
    }
  }
};